import React from 'react'

const Buttons = () => {
  return (
    <div>
        <nav className="text-[#1473AC]  my-5  lg:mx-10 md:mx-10 mx-3   justify-self-center flex-wrap flex gap-5">
         <button className="w-[150px] h-[50px] rounded-3xl  border-[grey] border-2 hover:bg-blue-900 hover:text-white">Products</button>
         <button className="w-[150px] h-[50px] rounded-3xl  border-[grey] border-2  hover:bg-blue-900 hover:text-white">Brands</button>
         <button className="w-[150px] h-[50px] rounded-3xl  border-[grey] border-2  hover:bg-blue-900 hover:text-white">Sales</button>
         <button className="w-[150px] h-[50px] rounded-3xl  border-[grey] border-2  hover:bg-blue-900 hover:text-white">Services</button>
         <button className="w-[150px] h-[50px] rounded-3xl  border-[grey] border-2  hover:bg-blue-900 hover:text-white">Resources</button>
        </nav>
    </div>
  )
}

export default Buttons
